import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/top-features-icon2.svg")